import { render, staticRenderFns } from "./Descriptions.vue?vue&type=template&id=6a004d2e&"
import script from "./Descriptions.vue?vue&type=script&lang=js&"
export * from "./Descriptions.vue?vue&type=script&lang=js&"
import style0 from "./Descriptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports